<template>
  <div id="RiskWarningDialog">
    <el-dialog title="预警设置" :visible.sync="dialogVisible" width="500px" :before-close="changeDialogVisible">
      <el-form ref="form" :rules="rules" :model="form" label-width="100px">
        <el-form-item label="预警类型">
          <el-input v-model="form.name" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="有效时段" prop="timeRange">
          <el-time-picker
            v-model="form.time"
            is-range
            arrow-control
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围"
            value-format="HH:mm:ss"
          >
          </el-time-picker>
        </el-form-item>
        <el-form-item label="预警项">
          <el-input v-model="form.name1" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="预警条件" prop="threshold">
          <el-row>
            <el-col :span="8">
              <el-select v-model="form.region" placeholder="">
                <el-option label="=" value="="></el-option>
                <el-option label=">" value=">"></el-option>
                <el-option label="<" value="<"></el-option>
              </el-select>
            </el-col>
            <el-col :span="2" :offset="2">阈值</el-col>
            <el-col :span="8" :offset="2">
              <el-input v-model="form.threshold"></el-input>
            </el-col>
            <el-col :span="2">%</el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="预警方式" prop="type">
          <el-checkbox-group v-model="form.type">
            <el-checkbox label="弹窗" name="type"></el-checkbox>
            <el-checkbox label="声音" name="type"></el-checkbox>
            <el-checkbox label="短信" name="type"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="预警频率">
          <el-row>
            <el-col :span="8">
              <el-select v-model="form.frequency" placeholder="">
                <el-option label="10秒" value="10"></el-option>
                <el-option label="20秒" value="20"></el-option>
                <el-option label="30秒" value="30"></el-option>
                <el-option label="40秒" value="40"></el-option>
                <el-option label="50秒" value="50"></el-option>
                <el-option label="60秒" value="60"></el-option>
              </el-select>
            </el-col>
            <el-col :span="6" :offset="2">内最多重复</el-col>
            <el-col :span="8">
              <el-select v-model="form.degree" placeholder="">
                <el-option label="1" value="1"></el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="开启预警">
          <el-switch v-model="form.delivery"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button class="el-cancel-btn" @click="changeDialogVisible">取消</el-button> -->
        <el-button type="primary" class="el-confirm-btn" :disabled="isClicked" @click="closePositionConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/*global util*/
import {
  mapGetters
} from 'vuex'
export default {
  name: 'Trade',
  props: ['dialogVisible'],
  data() {
    return {
      isClicked: false,
      form: {
        name: '风险预警',
        name1: '风险预警',
        time: [util.nowMinFormate(new Date()), util.nowMinFormate(new Date())],
        type: [],
        region: '=',
        threshold: '', // 阈值
        frequency: '10', // 频率
        degree: '1',
        delivery: false
      },
      rules: {

      }
    }
  },
  computed: {
    ...mapGetters(['sessionInfoGetter'])
  },
  watch: {
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const obj = JSON.parse(localStorage.getItem(`setting${this.sessionInfoGetter.tel}`))
      const {
        name = '风险预警',
        name1 = '风险预警',
        time = [util.nowMinFormate(new Date()), util.nowMinFormate(new Date())],
        type = [],
        region = '=',
        threshold = '', // 阈值
        frequency = '10', // 频率
        degree = '1',
        delivery = false
      } = obj
      this.form = {
        name,
        name1,
        time,
        type,
        region,
        threshold,
        frequency,
        degree,
        delivery
      }
    },
    // 关闭前操作
    changeDialogVisible() {
      this.$emit('closeWarnDialog')
    },
    closePositionConfirm() {
      const objStr = JSON.stringify(this.form)

      localStorage.setItem(`setting${this.sessionInfoGetter.tel}`, objStr)

      this.$emit('closeWarnDialog')
    }

  }
}
</script>
<style scoped lang="scss">

  li {
    position: relative;
    margin-bottom: 10px;
  }
  li:nth-child(1) span:nth-child(2n) {
    margin-right: 28%;
  }
  li:nth-child(2) div {
    float: left;
  }
  input[type="text"] {
    display: block;
    margin: 5px 0 0;
    height: 34px;
    border: 1px solid rgba(78, 89, 133, 1);
    border-radius: 5px;
    background: transparent;
  }
  li:nth-child(4) input[type="text"] {
    width: 73%;
  }
  input[type="text"]+span,
  li:nth-child(4) input[type="text"]+span+p {
    position: absolute;
    top: 35px;
    color: rgba(153, 204, 255, 0.4);
  }
  li:first-child input[type="text"]+span {
    right: 22%;
  }
  li:nth-child(4) input[type="text"]+span {
    right: 47%;
  }
  li:nth-child(4) input[type="text"]+span+p {
    right: 24%;
    color: white;
  }
  #RiskWarningDialog /deep/ .el-input.is-disabled .el-input__inner{
    background-color: transparent;
  }
  #RiskWarningDialog /deep/ .el-time-spinner__list .active{
    background: transparent;
  }
  #RiskWarningDialog /deep/ .el-date-editor .el-range-input{
    color: #C0C4CC;
  }
</style>
<style>
  #RiskWarningDialog .el-form-item__label {
    color: #fff;
  }
  #RiskWarningDialog .el-dialog {
    border-radius: 10px;
  }
   /* #RiskWarningDialog li{
     margin-right: 18%;
   } */
  #RiskWarningDialog .el-dialog__footer {
    padding:  20px;
  }
  #RiskWarningDialog .el-dialog__footer::after {
    content: "";
    display: block;
    clear: both;
  }
  #RiskWarningDialog .el-cancel-btn span,
  #RiskWarningDialog .el-confirm-btn span {
    color: #fff !important;
  }
  #RiskWarningDialog .el-confirm-btn,
  #RiskWarningDialog .el-cancel-btn {
    float: right;
    margin-right: 14%;
    width: 135px;
    height: 36px;
    line-height: 0px;
    border: 0;
    background-color: rgba(75, 85, 127, 1) !important;
  }
  #RiskWarningDialog .el-confirm-btn {
    background-color: rgba(122, 152, 248, 1) !important;
  }
 .el-time-spinner__wrapper.is-arrow .el-time-spinner__list .active{
    background: transparent !important;
  }
</style>
